const initialState = {
  loading: false,
  couponList: [],
  query: {
    page: 1,
    limit: 8,
    useStatus: '0'
  },
  total: 0,
  tabActive: '0',
  statusTabs: [
    {
      label: '未使用',
      value: '0',
    },
    {
      label: '已使用',
      value: '1',
    },
    {
      label: '已过期',
      value: '2',
    },
  ]
};

function reducer(state, action) {
  switch (action.type) {
    case 'setLoading':
      return { ...state, loading: action.payload };
    case 'setCouponList':
      return { ...state, couponList: action.payload };
    case 'setTabActive':
      return { ...state, tabActive: action.payload };
    case 'setQuery':
      return { ...state, query: action.payload };
    case 'setTotal':
      return { ...state, total: action.payload };
    default:
  }
}

const setLoading = payload => ({
  type: 'setLoading',
  payload,
});

const setCouponList = payload => ({
  type: 'setCouponList',
  payload,
});

const setTabActive = payload => ({
  type: 'setTabActive',
  payload,
});

const setQuery = payload => ({
  type: 'setQuery',
  payload,
});

const setTotal = payload => ({
  type: 'setTotal',
  payload,
});

export {
  initialState,
  reducer,
  setLoading,
  setCouponList,
  setTabActive,
  setQuery,
  setTotal
};
